import { createAsyncThunk } from "@reduxjs/toolkit";
import { getRequest } from "shared/utils/fetch-api";

export const fetchCheckAuth = createAsyncThunk(
    'contract/fetchCheckAuth',
    async (_, { rejectWithValue }) => {
        try {
            const response = await getRequest({}, 'dms-hr', 'checkSession', 'POST');
            const data = await response.json();
            if (data.Errors.length === 0) {
                return { answer: data.Result };
            } else {
                return rejectWithValue(data.Errors);
            }
        } catch (error: any) {
            return rejectWithValue(error.message);
        }
    }
);